import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import { getJson } from 'session';
import * as actions from '../action';
import * as c from '../constant';

function NewFixedFeesContent({
  handleAddModal,
  handleEdit,
  handleRemove,
  newFixedFeesId,
  getSingleNewFixedFees,
  newFixedFeesInfo,
  ordinanceRevisionId,
  isLoading,
  getReportAccess,
}) {
  useEffect(() => {
    if (_.isEmpty(newFixedFeesId)) return;
    getSingleNewFixedFees(newFixedFeesId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(newFixedFeesId)) return;
    getSingleNewFixedFees(newFixedFeesId);
  }, [newFixedFeesId]);

  const authProfile = getJson('profile') || {};

  const multiplier = _.get(newFixedFeesInfo, 'attributes.multiplier');
  const multiplierLabels = {
    no_of_employees_residing_manila: 'no_of_employees_residing_in_lgu',
    area: 'business_area',
    floor_area: 'total_floor_area',
  };
  const multiplierDisplay = multiplierLabels[multiplier] || multiplier;

  const handleDownload = (e) => {
    e.preventDefault();
    const reportAccessArgs = {
      path: `/api/v1/bpls/administrator/report/fixed_fees/generate_pdf`,
      query: {
        email: _.get(authProfile, 'email'),
        ordinance_revision_id: ordinanceRevisionId,
        output: 'D',
      },
    };
    getReportAccess(reportAccessArgs, (response) => {
      const src = `${response?.res?.res?.url || ''}`;
      window.location.href = src;
    });
  };

  if (isLoading) {
    return (
      <div className="container-fluid card-section-content">
        <div className="loading">
          <div className="spinner text-center">
            <span className="fas fa-1x fa-spin fa-spinner" />
          </div>
        </div>
      </div>
    );
  }

  const renderContent = () => {
    if (_.isEmpty(newFixedFeesInfo)) {
      return (
        <div className="d-flex flex-column align-items-center justify-content-center my-auto">
          <img
            src={emptyStateImage}
            className="img-responsive image-wrapper mb-4 mt-3"
            alt="Empty State"
          />
          <p className="emp-title mb-0"> No Item Found </p>
        </div>
      );
    }

    return (
      <div className="row bg-white pb-3">
        <div className="col-8">
          <h2 className="">{_.get(newFixedFeesInfo, 'attributes.name')}</h2>
          <span className="full-input">
            {_.get(newFixedFeesInfo, 'attributes.description')}
          </span>
        </div>
        <div className="col-4 d-flex">
          <div className="py-3 ml-auto">
            <button
              type="button"
              className="btn-blank"
              onClick={handleEdit(newFixedFeesInfo)}
            >
              <i className="far fa-edit icon-edit" />
            </button>
            <button
              type="button"
              className="btn-blank"
              onClick={handleRemove(newFixedFeesInfo)}
            >
              <i className="far fa-trash-alt icon-delete" />
            </button>
          </div>
        </div>
        <div className="col-12">
          <div className="form-wrapper mb-3 p-3">
            <table className="transaction-table table table-borderless table-sm ">
              <tbody>
                <tr>
                  <td className="text-dark" width="250">
                    Code
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td colSpan={4}>
                    <b>{_.get(newFixedFeesInfo, 'attributes.code')}</b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" width="250">
                    Name
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td colSpan={4}>
                    <b>{_.get(newFixedFeesInfo, 'attributes.name')}</b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" width="250">
                    Description
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td colSpan={4}>
                    <b>{_.get(newFixedFeesInfo, 'attributes.description')}</b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" width="250">
                    Multiplier
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td colSpan={4}>
                    <b>{multiplierDisplay}</b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" width="250">
                    Amount
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td colSpan={4}>
                    <b>{_.get(newFixedFeesInfo, 'attributes.amount_human')}</b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" width="250">
                    New
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td colSpan={4}>
                    <b>
                      {_.get(newFixedFeesInfo, 'attributes.for_new')
                        ? 'Yes'
                        : 'No'}
                    </b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" width="250">
                    Renewal
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td colSpan={4}>
                    <b>
                      {_.get(newFixedFeesInfo, 'attributes.for_renewal')
                        ? 'Yes'
                        : 'No'}
                    </b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" width="250">
                    Exclude Delinquent
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td colSpan={4}>
                    <b>
                      {_.get(newFixedFeesInfo, 'attributes.exclude_delinquent')
                        ? 'Yes'
                        : 'No'}
                    </b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" width="250">
                    Retirement
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td colSpan={4}>
                    <b>
                      {_.get(newFixedFeesInfo, 'attributes.for_retirement')
                        ? 'Yes'
                        : 'No'}
                    </b>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="container-fluid card-section-content">
      <div className="card-body">
        <div className="row pt-4 pb-2 bg-white">
          <div className="col-12 d-flex">
            <button
              type="button"
              onClick={handleAddModal}
              className="btn btn-primary cms-bg-color-primary cms-outline-primary btn-round font-weight-bold px-4 ml-auto"
            >
              Add Fixed Fee &nbsp;&nbsp;
              <i className="fas fa-plus" />
            </button>
            {!_.isEmpty(newFixedFeesInfo) && (
              <a
                className="btn btn-primary cms-bg-color-primary cms-outline-primary ml-1"
                href="#/"
                onClick={handleDownload}
              >
                <i className="fas fa-print" /> Generate PDF
              </a>
            )}
          </div>
        </div>

        {renderContent()}
      </div>
    </div>
  );
}

NewFixedFeesContent.propTypes = {
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  handleRemove: PropTypes.instanceOf(Function).isRequired,

  getSingleNewFixedFees: PropTypes.instanceOf(Function).isRequired,
  newFixedFeesInfo: PropTypes.instanceOf(Object).isRequired,
  newFixedFeesId: PropTypes.string.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
  isLoading: PropTypes.bool.isRequired,
  getReportAccess: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  newFixedFeesInfo: _.get(api, `${c.GET_SINGLE_NEW_FIXED_FEES}.item`) || {},
  newFixedFeesId: _.get(match, 'params.newFixedFeesId') || '',
  isLoading: api.loading.indexOf(c.GET_SINGLE_NEW_FIXED_FEES) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(NewFixedFeesContent);
